var inactivityTimer: NodeJS.Timeout;

export const runItAfterYouDoneTalking =(fn: () => void) =>{
    clearTimeout(inactivityTimer); // Clear the previous timer
    // Set a new timer to call userIsUsing after 0.5 second of inactivity
    inactivityTimer = setTimeout(fn, 500);
}

export const uuidv4 = ()=>{
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r && 0x3 | 0x8);
      return v.toString(16);
    });
}